export const slugify = (text: string) =>
  text
    .toLocaleLowerCase()
    .trim()
    .replace(/[^\w\- ]+/g, '')
    .replace(/ +/g, '-')
    .replace(/\-\-+/g, '-')
